import React from 'react'

const Eye = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/eye',
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <g fill='none' fillRule='evenodd'>
      <path
        d='M9.982 5C7.314 5 4.654 6.667 2 10c2.654 3.333 5.314 5 7.982 5s5.34-1.667 8.018-5c-2.677-3.333-5.35-5-8.018-5z'
        stroke={primaryColor}
        strokeWidth='1.5'
        strokeLinecap='square'
      />
      <circle fill={primaryColor} cx={10} cy={10} r={2} />
    </g>
  </svg>
)

export default Eye
